'use strict';

import Vue from 'vue';

const eventBus = new Vue({
    name: 'event-bus'
});

export default eventBus;
